import AddPatientModal from '../addPatientModal/AddPatient.modal';
export default AddPatientModal;
